module.exports = __webpack_public_path__ + "img/7-1-IMG_3001.e87afe9f.png";